<template>
    <v-modal-validated title="Editar información del cliente"
                       accept-button-text="Guardar"
                       close-button-text="Cerrar"
                       id="edit_clients_modal"
                       size="xl"
                       :rules="rules"
                       v-if="rules_loaded"
                       @closed="closeModal"
                       @accepted="editClient">
        <div class="form-container">
            <div class="user-form row">
                <div class="form-group col-5">
                    <label>Número del cliente*:</label>
                    <Field type="text" name="code" class="form-control" v-model="client.code"/>

                    <ErrorMessage name="code"/>
                </div>

                <div class="form-group col-7">
                    <label>Nombre*:</label>
                    <Field type="text" name="name" class="form-control" v-model="client.name"/>

                    <ErrorMessage name="name"/>
                </div>
            </div>

            <div class="user-form row">
                <div class="form-group col-5">
                    <label>Apellidos*:</label>
                    <Field type="text" name="surname" class="form-control" v-model="client.surname"/>

                    <ErrorMessage name="surname"/>
                </div>

                <div class="form-group col-7">
                    <label>DNI/NIE*:</label>
                    <Field type="text" name="dni" class="form-control" v-model="client.dni"/>

                    <ErrorMessage name="dni"/>
                </div>
            </div>

            <div class="user-form row">
                <div class="more-fields row" id="more_fields">
                    <div class="form-group col-12">
                        <label>Responsable: </label>

                        <select class="form-control" disabled v-if="users.length === 0">
                            <option selected>- No existen usuarios en la aplicación -</option>
                        </select>

                        <div class="input-group" v-else>
                            <Field type="text"
                                   id="responsible_id"
                                   name="responsible_id"
                                   class="form-control"
                                   v-model="client.responsible_id">

                                <v-select-jq aria-label="Responsable"
                                             parent-id="edit_clients_modal"
                                             placeholder="- Seleccionar -"
                                             ref="selectUsers"
                                             :options="users"
                                             :value="client.responsible_id"
                                             @update:modelValue="client.responsible_id = $event">
                                </v-select-jq>
                            </Field>

                            <button class="delete-date" @click="$refs.selectUsers.removeAll();"
                                    :disabled="!client.responsible_id  ? true : null">
                                <span class="uq-icon bi-x-lg"></span>
                            </button>
                        </div>

                        <ErrorMessage name="responsible_id"/>
                    </div>
                </div>
            </div>

            <div class="user-form row">
                <div class="more-fields row" id="more_fields">
                    <div class="form-group" :class="field.class" v-for="field in fields">
                        <label>{{ field.display_name }}{{
                                !!field.rules && isRequired(field.rules) === true ? '*' : null
                            }}:</label>
                        <Field :type="field.type"
                               class="form-control"
                               :name="field.name"
                               :list="field.datalist ? field.datalist : null"
                               :disabled="field.disabled === true ? true : null"
                               v-if="field.name !== 'extra_data' && field.name !== 'town' && field.name !== 'origen'"
                               v-model="client[field.name]"/>

                        <Field id="town_datalist" :name="field.name" v-if="field.name === 'town'" class="form-control"
                               v-model="client[field.name]">
                            <v-select-jq
                                class="form-control select2"
                                parent-id="edit_clients_modal"
                                :options="townsOptions"
                                :modelValue="client[field.name] + ' (' + client['province'] + ')'"
                                :value="client[field.name] + ' (' + client['province'] + ')'"
                                @update:modelValue="townUpdated($event)">
                            </v-select-jq>
                        </Field>

                        <datalist id="type_road_datalist" v-if="field.name === 'type_road'">
                            <option :value="element" v-for="element in forms_help.road_types">{{
                                    element
                                }}
                            </option>
                        </datalist>

                        <Field as="textarea" :name="field.name" class="form-control textarea"
                               v-if="field.name === 'extra_data'" v-model="client[field.name]"/>

                        <ErrorMessage :name="field.name"/>

                        <Field id="origen_datalist" type="text" :name="field.name" v-if="field.name === 'origen'" class="form-control" aria-label="type" v-model="client[field.name]">
                            <select class="form-select" aria-label="Origen" v-model="client[field.name]">
                                <option :value="element.value" v-for="element in clients_origins">
                                    {{ element.display_name }}
                                </option>
                            </select>
                        </Field>
                    </div>
                </div>
            </div>

            <div class="user-form row">
                <div class="more-fields col-4">
                    <div class="form-group">
                        <label class="form-label"
                               for="firmada_usura">
                            Firmada usura
                        </label>
                        <input
                            class="form-check-input"
                            type="checkbox"
                            name="firmada_usura"
                            id="firmada_usura"
                            v-model="client['firmada_usura']"
                        >
                    </div>
                </div>

                <div class="more-fields col-4">
                    <div class="form-group">
                        <label class="form-label"
                               for="firmada_hipoteca">
                            Firmada hipoteca
                        </label>
                        <input
                            class="form-check-input"
                            type="checkbox"
                            name="firmada_hipoteca"
                            id="firmada_hipoteca"
                            v-model="client['firmada_hipoteca']"
                        >
                    </div>
                </div>

                <div class="more-fields col-4">
                    <div class="form-group">
                        <label class="form-label"
                               for="firmada_listas_morosidad">
                            Firmada listas morosidad
                        </label>
                        <input
                            class="form-check-input"
                            type="checkbox"
                            name="firmada_listas_morosidad"
                            id="firmada_listas_morosidad"
                            v-model="client['firmada_listas_morosidad']"
                        >
                    </div>
                </div>

                <div class="more-fields col-4">
                    <div class="form-group">
                        <label class="form-label"
                               for="firmada_otras_hojas_encargo">
                            Firmada otras hojas encargo
                        </label>
                        <input
                            class="form-check-input"
                            type="checkbox"
                            name="firmada_otras_hojas_encargo"
                            id="firmada_otras_hojas_encargo"
                            v-model="client['firmada_otras_hojas_encargo']"
                        >
                    </div>
                </div>

                <div class="more-fields col-8" v-if="client['firmada_otras_hojas_encargo'] === 'true' || client['firmada_otras_hojas_encargo'] === true">
                    <div class="form-group">
                        <label class="form-label"
                               for="observaciones_otras_hojas_encargo">
                            Observaciones otras hojas encargo
                        </label>
                        <input
                            class="form-control"
                            type="text"
                            name="observaciones_otras_hojas_encargo"
                            id="observaciones_otras_hojas_encargo"
                            v-model="client['observaciones_otras_hojas_encargo']"
                        >
                    </div>
                </div>
            </div>
        </div>
    </v-modal-validated>
</template>

<script>
import {getCCAAs, getProvinces, getRoadTypes, getTowns} from "../../../helpers/DataHelper";
import {editClient} from "../../../helpers/requests/RequestsClients";
import VModalValidated from "../../general/VModalValidated";
import {ErrorMessage, Field, Form} from "vee-validate";
import * as yup from "yup";
import {addRule, isRequired} from "../../../helpers/form";
import VSelectJq from "../../general/VSelectJQ";
import {getUsers} from "../../../helpers/requests/RequestsUsers";

export default {
    name: "ClientsListEditModal",
    components: {VModalValidated, Form, Field, ErrorMessage, VSelectJq},
    props: {
        client: {
            type: Object,
            required: true,
        }
    },
    data() {
        return {
            fields: [],
            rules_loaded: false,

            townsOptions: [],

            forms_help: {
                ccaas: getCCAAs(),
                provinces: getProvinces(),
                towns: getTowns(),
                road_types: getRoadTypes(),
            },

            rules: {
                code: yup.string().required('Debes incluir un número de cliente').max(50, 'Debe tener como máximo 50 caracteres'),
                name: yup.string().required('Debes incluir un nombre').max(50, 'Debe tener como máximo 50 caracteres'),
                surname: yup.string().required('Debes incluir como mínimo un apellido').max(50, 'Debe tener como máximo 50 caracteres'),
                dni: yup.string().required('Debes incluir un DNI').max(10, 'Debe tener como máximo 10 caracteres'),
                user_id: yup.string().nullable(),
            },

            users: [],
        }
    },
    setup() {
        return {
            isRequired,
        }
    },
    mounted() {
        this.fields = require('../../../config/form_fields.json').clients;

        this.rules_loaded = true;

        // Rules: empezar siempre con 'string'
        // let rules = ['string', 'required', 'min:5', 'max:10'];

        for (let i in this.fields) {
            let field = this.fields[i];
            let add = yup;

            for (let j in field.rules) {
                let rule = field.rules[j];

                let name = rule.name;
                let message = rule.message;
                add = addRule(add, name, message);
            }

            this.rules[field.name] = add;
        }

        this.rules = yup.object(this.rules);

        let array = Object.keys(this.forms_help.towns);
        for (let i in array) {
            let town = array[i];
            this.townsOptions.push({id: town, text: town,});
        }

        this.clients_origins = require('../../../config/clients_origins.json');

        this.loadAvailableUsers();
    },
    methods: {
        async editClient(data) {
            try {
                // Manually append some custom but dynamic data
                const moreDynamicFields = ['firmada_usura', 'firmada_hipoteca', 'firmada_listas_morosidad',
                'firmada_otras_hojas_encargo', 'observaciones_otras_hojas_encargo'];

                moreDynamicFields.forEach((field) => {
                    if (field === 'observaciones_otras_hojas_encargo') {
                        // This one is a text, not a checkbox
                        data[field] = this.client[field] ?? '-';
                    } else {
                        data[field] = (this.client[field] === 'true' || this.client[field] === true) ? 'true' : 'false';
                    }
                })

                data.id = this.client.id;
                data.town = data.town.replaceAll('(' + data.province + ')', '').trim();

                await editClient(data);

                // TODO: Ask confirmation

                this.$store.dispatch('app/setToastMessage', 'Cambios guardados con éxito');

                this.closeModal();

            } catch (e) {
                this.$store.dispatch('app/setErrorToastMessage', 'Error al guardar los cambios');
            }
        },
        townUpdated(town) {
            if (this.forms_help.towns[town] !== undefined) {
                let location = this.forms_help.towns[town];
                // set ccaa | province
                this.client['town'] = location.town;
                this.client['community'] = location.ccaa;
                this.client['province'] = location.province;
            }
        },
        closeModal() {
            this.$emit('closed');
        },
        async loadAvailableUsers() {
            let users = await getUsers();

            if (!users.meta) {
                this.users = Object.values(users).map((user) => {
                    return {id: user.id, text: user.name + ' (' + user.email + ')'};
                });
            }
        },
    },
}
</script>
